import React from "react";
import { Row, Col, Button, Radio } from 'antd';
import SelectComponent from '../generic/select/select';
import Span from "../generic/span/span";
import Title from "../generic/title/title";
import InputText from "../generic/input/input-text";
import InputRut from "../generic/input/input-rut";
import InputNumerico from "../generic/input/input-numerico";
import TextAera from "../generic/text-area/text-area";
import UploadeFileReclamo from "../generic/upload/upload"
import {
    GoogleReCaptchaProvider,
    GoogleReCaptcha
} from 'react-google-recaptcha-v3';

/** 
 *
 *  SE SOLICITO QUE ESTE FORMULARIO FUERA IGUAL QUE AtencionCliente Y SOLO AGREGAR LOS CAMBIOS (SIN LIMPIEZA)
 * 
 */
const { valRut, valMail, valNombre, valTexto, valNumero, valCaptcha, obtenerBoletosByTransaccion, validarTransaccion, obtenerBancos, obtenerTipoDeCuenta, validaFormularioDevoluciones } = require("../generic/utils/utils");

export default class DevolucionesCliente extends React.Component {

    constructor(props) {
        super();
        this.verifyCaptcha = this.verifyCaptcha.bind(this);
        let precargaForm = props.precargaForm;
        this.state = {
            precarga: precargaForm !== null ? true : false,
            form: {
                reclamo: {
                    detalleReclamo: {
                        motivo: precargaForm !== null ? precargaForm.detalleReclamo.motivo : null,
                        subMotivo: precargaForm !== null ? precargaForm.detalleReclamo.subMotivo : null,
                        tipoReclamo: precargaForm !== null ? precargaForm.detalleReclamo.tipoReclamo : null,
                        comentario: precargaForm !== null ? precargaForm.detalleReclamo.comentario : null,
                        tipoDeDevolucion: precargaForm !== null ? precargaForm.detalleReclamo.tipoDeDevolucion : null,
                        files: precargaForm !== null ? precargaForm.detalleReclamo.files : null,
                        linea: null,
                    },
                    flag: {
                        flgBoletos: precargaForm !== null ? precargaForm.flag.flgBoletos : null,
                        flgDetalleCuenta: precargaForm !== null ? precargaForm.flag.flgDetalleCuenta : null,
                    },
                    comprador: {
                        rut: precargaForm !== null ? precargaForm.comprador.rut : null,
                        dv: precargaForm !== null ? precargaForm.comprador.dv : null,
                        nombre: precargaForm !== null ? precargaForm.comprador.nombre : null,
                        apellidoPaterno: precargaForm !== null ? precargaForm.comprador.apellidoPaterno : null,
                        apellidoMaterno: precargaForm !== null ? precargaForm.comprador.apellidoMaterno : null,
                        cuenta: {
                            banco: precargaForm !== null ? precargaForm.cuenta.banco : null,
                            tipo: precargaForm !== null ? precargaForm.cuenta.tipo : null,
                            numero: precargaForm !== null ? precargaForm.cuenta.numero : null,
                        },
                    },
                    solicitante: {
                        rut: precargaForm !== null ? precargaForm.solicitante.rut : null,
                        dv: precargaForm !== null ? precargaForm.solicitante.dv : null,
                        nombre: precargaForm !== null ? precargaForm.solicitante.nombre : null,
                        apellidoPaterno: precargaForm !== null ? precargaForm.solicitante.apellidoPaterno : null,
                        apellidoMaterno: precargaForm !== null ? precargaForm.solicitante.apellidoMaterno : null,
                        correo: precargaForm !== null ? precargaForm.solicitante.correo : null,
                        telefono: precargaForm !== null ? precargaForm.solicitante.telefono : null,
                        celular: precargaForm !== null ? precargaForm.solicitante.celular : null,
                    },
                    compradorTurclub: {
                        rut: precargaForm !== null ? precargaForm.comprador.rut : null,
                        dv: precargaForm !== null ? precargaForm.comprador.dv : null,
                        nombre: precargaForm !== null ? precargaForm.comprador.nombre : null,
                        apellidoPaterno: precargaForm !== null ? precargaForm.comprador.apellidoPaterno : null,
                        apellidoMaterno: precargaForm !== null ? precargaForm.comprador.apellidoMaterno : null,
                    },
                    detalleVenta: {
                        transaccion: precargaForm !== null ? precargaForm.detalleVenta.transaccion : null,
                        formaDePago: precargaForm !== null ? precargaForm.detalleVenta.formaDePago : null,
                    },
                    boleto: {
                        listaBoletos: [],
                        listaBoletosAnular: []
                    }
                },
                alerta: {
                    mensaje: {
                        comprador: {
                            rut: '',
                            nombre: '',
                            apellidoPaterno: '',
                            apellidoMaterno: '',
                        },
                        solicitante: {
                            rut: '',
                            nombre: '',
                            apellidoPaterno: '',
                            apellidoMaterno: '',
                            telefono: '',
                            celular: '',
                            correo: '',
                        },
                        cuenta: {
                            banco: '',
                            banco_generico: props.textos.validations.banco.message,
                            tipo: '',
                            tipo_generico: props.textos.validations.tipoCuenta.message,
                            numero: ''
                        },
                        venta: {
                            transaccion: "",
                            transaccion_generico: props.textos.validations.transaccion.message
                        },
                        reclamo: {
                            comentario: "",
                            contenedor: "",
                            tipoDevolucion: "",
                        },
                        boleto: {
                            boletosAnular: "",
                            boletosAnular_generico: props.textos.validations.boleto.message_3
                        }
                    },
                    estado: {
                        comprador: {
                            rut: false,
                            nombre: false,
                            apellidoPaterno: false,
                            apellidoMaterno: false,
                        },
                        solicitante: {
                            rut: false,
                            nombre: false,
                            apellidoPaterno: false,
                            apellidoMaterno: false,
                            telefono: false,
                            celular: false,
                            correo: false,
                        },
                        cuenta: {
                            banco: false,
                            tipo: false,
                            numero: false,
                        },
                        venta: {
                            transaccion: false,
                        },
                        reclamo: {
                            comentario: false,
                            contenedor: false,
                            tipoDevolucion: false,
                        },
                        boleto: {
                            boletosAnular: false
                        }
                    },
                },
                bancos: new Map(),
                tiposDeCuenta: new Map(),
                textos: props.textos.FORMULARIO_DEVOLUCION,
            },
            captchaVerify: false
        }

        this.setReclamo();
    }

    setReclamo = async (even) => {

        let formValue = this.state.form;
        formValue.reclamo.detalleReclamo.motivo = 80;
        formValue.reclamo.detalleReclamo.subMotivo = 809;
        formValue.reclamo.detalleReclamo.tipoReclamo = 80904;

        this.setState({ form: formValue });
    }

    validaRut = async (event) => {

        let data = await valRut(event);
        let formValue = this.state.form;
        let id = event.target.id;

        switch (id) {
            case "rutcomp":
                formValue.reclamo.comprador.rut = data.rut;
                formValue.reclamo.comprador.dv = data.dv;
                formValue.alerta.mensaje.comprador.rut = data.txtSpan;
                formValue.alerta.estado.comprador.rut = data.activeSpan;
                break;
            case "rutsoli":
                formValue.reclamo.solicitante.rut = data.rut;
                formValue.reclamo.solicitante.dv = data.dv;
                formValue.alerta.mensaje.solicitante.rut = data.txtSpan;
                formValue.alerta.estado.solicitante.rut = data.activeSpan;
                break;
            default:
                break;
        }

        this.setState({ form: formValue })

    }

    validaCorreo = async (event) => {

        let data = await valMail(event);
        let formValue = this.state.form;

        formValue.alerta.estado.solicitante.correo = data.activeSpan;
        formValue.alerta.mensaje.solicitante.correo = data.txtSpan;
        formValue.reclamo.solicitante.correo = data.correo;

        this.setState({ form: formValue });

    }

    validaNombre = async (event) => {

        let data = await valNombre(event);
        let formValue = this.state.form;
        let id = event.target.id;

        switch (id) {
            case "appatsoli":
                formValue.reclamo.solicitante.apellidoPaterno = data.texto;
                formValue.alerta.estado.solicitante.apellidoPaterno = data.activeSpan;
                formValue.alerta.mensaje.solicitante.apellidoPaterno = data.txtSpan;
                break;
            case "apmatsoli":
                formValue.reclamo.solicitante.apellidoMaterno = data.texto;
                formValue.alerta.estado.solicitante.apellidoMaterno = data.activeSpan;
                formValue.alerta.mensaje.solicitante.apellidoMaterno = data.txtSpan;
                break;
            case "nomsoli":
                formValue.reclamo.solicitante.nombre = data.texto;
                formValue.alerta.estado.solicitante.nombre = data.activeSpan;
                formValue.alerta.mensaje.solicitante.nombre = data.txtSpan;
                break;
            case "nomcomp":
                formValue.reclamo.comprador.nombre = data.texto;
                formValue.alerta.estado.comprador.nombre = data.activeSpan;
                formValue.alerta.mensaje.comprador.nombre = data.txtSpan;
                break;
            case "appatcomp":
                formValue.reclamo.comprador.apellidoPaterno = data.texto;
                formValue.alerta.estado.comprador.apellidoPaterno = data.activeSpan;
                formValue.alerta.mensaje.comprador.apellidoPaterno = data.txtSpan;
                break;
            case "apmatcomp":
                formValue.reclamo.comprador.apellidoMaterno = data.texto;
                formValue.alerta.estado.comprador.apellidoMaterno = data.activeSpan;
                formValue.alerta.mensaje.comprador.apellidoMaterno = data.txtSpan;
                break;
            default:
                break;
        }

        this.setState({ form: formValue })
    }

    validaTexto = async (event) => {

        let data = await valTexto(event);
        let formValue = this.state.form;

        formValue.comentario = data.texto;
        formValue.reclamo.detalleReclamo.comentario = data.texto;
        formValue.alerta.estado.reclamo.comentario = data.activeSpan;
        formValue.alerta.mensaje.reclamo.comentario = data.txtSpan;
        formValue.alerta.estado.reclamo.contenedor = data.activaCon;
        formValue.alerta.mensaje.reclamo.contenedor = data.txtCon;

        this.setState({ form: formValue })

    }

    validaNumerico = async (event) => {

        let formValue = this.state.form;
        let id = event.target.id;
        let data = (id === "trxsoli") ? await validarTransaccion(event) : await valNumero(event);

        switch (id) {
            case "trxsoli":
                let datoVtwst99 = await obtenerBoletosByTransaccion(data.numero, data.activeSpan);
                let bancos = await obtenerBancos();
                let cuentas = await obtenerTipoDeCuenta();
                formValue.reclamo.compradorTurclub = datoVtwst99.datosComprador;
                formValue = await this.setLimpiarComprador(formValue);
                let validaListadoBoleto = datoVtwst99.data.length === 0 ? false : true;

                if (!data.activeSpan && !validaListadoBoleto) {
                    data.txtSpan = formValue.alerta.mensaje.venta.transaccion_generico;
                    data.activeSpan = true;
                }

                formValue.bancos = bancos;
                formValue.tiposDeCuenta = cuentas;
                formValue.reclamo.flag.flgBoletos = validaListadoBoleto;
                formValue.reclamo.boleto.listaBoletos = datoVtwst99.data;
                formValue.reclamo.detalleVenta.formaDePago = datoVtwst99.codigoFormaDePago;
                formValue.reclamo.boleto.listaBoletosAnular = [];
                formValue.reclamo.flag.flgDetalleCuenta = false;
                formValue.reclamo.detalleVenta.transaccion = data.numero;
                formValue.reclamo.detalleReclamo.tipoDeDevolucion = null;
                formValue.alerta.estado.boleto.boletosAnular = false;
                formValue.alerta.estado.venta.transaccion = data.activeSpan;
                formValue.alerta.mensaje.venta.transaccion = data.txtSpan;
                break;

            case "telesoli":
                formValue.reclamo.solicitante.telefono = data.numero;
                formValue.alerta.estado.solicitante.telefono = data.activeSpan;
                formValue.alerta.mensaje.solicitante.telefono = data.txtSpan;
                break;

            case "celsoli":
                formValue.reclamo.solicitante.celular = data.numero;
                formValue.alerta.estado.solicitante.celular = data.activeSpan;
                formValue.alerta.mensaje.solicitante.celular = data.txtSpan;
                break;

            case "cuenta":
                formValue.reclamo.comprador.cuenta.numero = data.numero;
                formValue.alerta.estado.cuenta.numero = data.activeSpan;
                formValue.alerta.mensaje.cuenta.numero = data.txtSpan;
                break;

            default:
                break;
        }

        this.setState({ form: formValue });
    }

    setValidaciones(data, formulario) {

        formulario.alerta.mensaje.comprador.rut = data.comprador.rut.mensaje;
        formulario.alerta.mensaje.comprador.nombre = data.comprador.nombre.mensaje;
        formulario.alerta.mensaje.comprador.apellidoPaterno = data.comprador.apellidoPaterno.mensaje;
        formulario.alerta.mensaje.comprador.apellidoMaterno = data.comprador.apellidoMaterno.mensaje;
        formulario.alerta.estado.comprador.rut = data.comprador.rut.estado;
        formulario.alerta.estado.comprador.nombre = data.comprador.nombre.estado;
        formulario.alerta.estado.comprador.apellidoPaterno = data.comprador.apellidoPaterno.estado;
        formulario.alerta.estado.comprador.apellidoMaterno = data.comprador.apellidoMaterno.estado;

        formulario.alerta.mensaje.solicitante.rut = data.solicitante.rut.mensaje;
        formulario.alerta.mensaje.solicitante.nombre = data.solicitante.nombre.mensaje;
        formulario.alerta.mensaje.solicitante.apellidoPaterno = data.solicitante.apellidoPaterno.mensaje;
        formulario.alerta.mensaje.solicitante.apellidoMaterno = data.solicitante.apellidoMaterno.mensaje;
        formulario.alerta.mensaje.solicitante.telefono = data.solicitante.telefono.mensaje;
        formulario.alerta.mensaje.solicitante.celular = data.solicitante.celular.mensaje;
        formulario.alerta.mensaje.solicitante.correo = data.solicitante.correo.mensaje;
        formulario.alerta.estado.solicitante.rut = data.solicitante.rut.estado;
        formulario.alerta.estado.solicitante.nombre = data.solicitante.nombre.estado;
        formulario.alerta.estado.solicitante.apellidoPaterno = data.solicitante.apellidoPaterno.estado;
        formulario.alerta.estado.solicitante.apellidoMaterno = data.solicitante.apellidoMaterno.estado;
        formulario.alerta.estado.solicitante.telefono = data.solicitante.telefono.estado;
        formulario.alerta.estado.solicitante.celular = data.solicitante.celular.estado;
        formulario.alerta.estado.solicitante.correo = data.solicitante.correo.estado;

        formulario.alerta.mensaje.cuenta.banco = data.cuenta.banco.mensaje;
        formulario.alerta.mensaje.cuenta.tipo = data.cuenta.tipo.mensaje;
        formulario.alerta.mensaje.cuenta.numero = data.cuenta.numero.mensaje;
        formulario.alerta.estado.cuenta.banco = data.cuenta.banco.estado;
        formulario.alerta.estado.cuenta.tipo = data.cuenta.tipo.estado;
        formulario.alerta.estado.cuenta.numero = data.cuenta.numero.estado;

        formulario.alerta.mensaje.venta.transaccion = data.venta.transaccion.mensaje;
        formulario.alerta.estado.venta.transaccion = data.venta.transaccion.estado;

        formulario.alerta.mensaje.reclamo.comentario = data.reclamo.comentario.mensaje;
        formulario.alerta.estado.reclamo.comentario = data.reclamo.comentario.estado;
        formulario.alerta.mensaje.reclamo.tipoDevolucion = data.reclamo.tipoDeDevolucion.mensaje;
        formulario.alerta.estado.reclamo.tipoDevolucion = data.reclamo.tipoDeDevolucion.estado;

        formulario.alerta.mensaje.boleto.boletosAnular = data.boleto.boletosAnular.mensaje;
        formulario.alerta.estado.boleto.boletosAnular = data.boleto.boletosAnular.estado;


        this.setState({ form: formulario });
    }

    cargaFile = async (e) => {

        let arch = [];
        let count = 0;
        let formValue = this.state.form;

        e.forEach(number => {
            if (parseInt(number.size) < 2281 && count < 3) {
                arch.push(number)
                count = count + 1;
            }
        })

        formValue.reclamo.detalleReclamo.files = arch;
        this.setState({ form: formValue })
    }

    verifyCaptcha(value) {
        if (value) {
            this.setState({
                captchaVerify: true
            })
        }
    }

    handleOk = async (e) => {


        let estado = this.state;
        let formulario = estado.form;
        let validacion = await validaFormularioDevoluciones(formulario);
        let verifyCaptcha = await valCaptcha(this.state.captchaVerify);

        this.setState({ txtSpanCaptcha: verifyCaptcha.txtSpan, activarSpanCaptcha: verifyCaptcha.activeSpan });

        if (validacion.validacion && verifyCaptcha.verifyCaptcha) {
            this.props.onComplete(formulario);
        } else {
            this.setValidaciones(validacion, formulario);
        }

    }

    isChecked = async (e) => {

        let formValue = this.state.form;


        if (e.target.checked) {
            if (formValue.reclamo.boleto.listaBoletosAnular.length === 0) {
                formValue.reclamo.boleto.listaBoletosAnular.push(e.target.value);
            } else {
                let boletoAgregado = formValue.reclamo.boleto.listaBoletosAnular.filter((item) => item === e.target.value);

                if (boletoAgregado.length === 0) {
                    formValue.reclamo.boleto.listaBoletosAnular.push(e.target.value);
                }
            }
            formValue.alerta.estado.boleto.boletosAnular = false;
            formValue.alerta.mensaje.boleto.boletosAnular = '';
        } else {
            if (formValue.reclamo.boleto.listaBoletosAnular.length !== 0) {
                formValue.reclamo.boleto.listaBoletosAnular = formValue.reclamo.boleto.listaBoletosAnular.filter((item) => item !== e.target.value);
            }
            if (formValue.reclamo.boleto.listaBoletosAnular.length === 0) {
                formValue.alerta.estado.boleto.boletosAnular = true;
                formValue.alerta.mensaje.boleto.boletosAnular = formValue.alerta.mensaje.boleto.boletosAnular_generico;
            }
        }

        this.setState({ form: formValue })
    }

    tipoDeDevolucion = async (e) => {
        let formValue = this.state.form;
        if (e.target.value === 2) {
            formValue.reclamo.flag.flgDetalleCuenta = true;
            formValue.reclamo.detalleReclamo.tipoDeDevolucion = 2;
        } else {
            formValue.reclamo.flag.flgDetalleCuenta = false;
            formValue.reclamo.detalleReclamo.tipoDeDevolucion = 1;
        }
        formValue = await this.setLimpiarComprador(formValue);
        this.setState({ form: formValue });
    }

    setBanco = async (e) => {
        let formValue = this.state.form;
        if (e === undefined) {
            formValue.alerta.estado.cuenta.banco = true;
            formValue.alerta.mensaje.cuenta.banco = formValue.alerta.mensaje.cuenta.banco_generico;
            formValue.reclamo.comprador.cuenta.banco = "";
        } else {
            formValue.alerta.estado.cuenta.banco = false;
            formValue.alerta.mensaje.cuenta.banco = "";
            formValue.reclamo.comprador.cuenta.banco = e;
        }
        this.setState({ form: formValue });
    }

    setCuenta = async (e) => {
        let formValue = this.state.form;
        if (e === undefined) {
            formValue.alerta.estado.cuenta.tipo = true;
            formValue.alerta.mensaje.cuenta.tipo = formValue.alerta.mensaje.cuenta.tipo_generico;
            formValue.reclamo.comprador.cuenta.tipo = "";
        } else {
            formValue.alerta.estado.cuenta.tipo = false;
            formValue.alerta.mensaje.cuenta.tipo = "";
            formValue.reclamo.comprador.cuenta.tipo = e;
        }
        this.setState({ form: formValue });
    }

    setLimpiarComprador = async (formValue) => {
        if (formValue.reclamo.flag.flgDetalleCuenta) {
            formValue.reclamo.comprador.rut = "";
            formValue.reclamo.comprador.dv = "";
            formValue.reclamo.comprador.nombre = "";
            formValue.reclamo.comprador.apellidoPaterno = "";
            formValue.reclamo.comprador.apellidoMaterno = "";
            formValue.reclamo.comprador.cuenta.banco = null;
            formValue.reclamo.comprador.cuenta.tipo = null;
            formValue.reclamo.comprador.cuenta.numero = "";
        } else {
            let compradorTurclub = formValue.reclamo.compradorTurclub;

            if (compradorTurclub.rut === '') {
                compradorTurclub.rut = formValue.reclamo.solicitante.rut;
                compradorTurclub.dv = formValue.reclamo.solicitante.dv;
                compradorTurclub.nombre = formValue.reclamo.solicitante.nombre;
                compradorTurclub.apellidoPaterno = formValue.reclamo.solicitante.apellidoPaterno;
                compradorTurclub.apellidoMaterno = formValue.reclamo.solicitante.apellidoMaterno;
            }
            compradorTurclub.cuenta = formValue.reclamo.comprador.cuenta;
            formValue.reclamo.comprador = compradorTurclub;

            formValue.alerta.estado.comprador.nombre = false;
            formValue.alerta.estado.comprador.apellidoPaterno = false;
            formValue.alerta.estado.comprador.apellidoMaterno = false;
            formValue.alerta.estado.comprador.rut = false;

            formValue.reclamo.comprador.cuenta.banco = -1;
            formValue.reclamo.comprador.cuenta.tipo = -1;
            formValue.reclamo.comprador.cuenta.numero = "";
        }

        formValue.alerta.mensaje.reclamo.tipoDevolucion = '';
        formValue.alerta.estado.reclamo.tipoDevolucion = false;

        return formValue;

    }

    render() {
        return (
            <div className="box-content">
                <Title h={1} text={this.state.form.textos.HEADER.TITULOS.TIT_DEVOLUCIONES} />
                <div className="texto-justify"><p><Span text={this.state.form.textos.HEADER.PARRAFO.PARRAFO_1} /></p></div>
                <div className="texto-justify"><p><Span text={this.state.form.textos.HEADER.PARRAFO.PARRAFO_2} /></p></div>
                <div className="texto-justify"><p><Span text={this.state.form.textos.HEADER.PARRAFO.PARRAFO_3} /></p></div>
                <Row className="transaction-row">
                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="label">
                                <Span css="word" text={this.state.form.textos.BODY.INPUT.HEADER.SOLICITANTE.NOMBRE} />
                            </div>
                            <InputText id="nomsoli" placeholder={this.state.form.textos.BODY.INPUT.PLACEHOLDER.SOLICITANTE.NOMBRE} value={this.state.form.reclamo.solicitante.nombre} max={20} onlyText={true} onChange={this.validaNombre} />
                            {this.state.form.alerta.estado.solicitante.nombre ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.solicitante.nombre} /></div> : <div></div>}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                            <div style={{ width: "97%" }}>
                                <div className="label">
                                    <Span css="word" text={this.state.form.textos.BODY.INPUT.HEADER.SOLICITANTE.APELLIDO_PAT} />
                                </div>
                                <InputText id="appatsoli" placeholder={this.state.form.textos.BODY.INPUT.PLACEHOLDER.SOLICITANTE.APELLIDO_PAT} value={this.state.form.reclamo.solicitante.apellidoPaterno} max={20} onlyText={true} onChange={this.validaNombre} />
                                {this.state.form.alerta.estado.solicitante.apellidoPaterno ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.solicitante.apellidoPaterno} /></div> : <div></div>}
                            </div>
                        </Col>
                    </Row>

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="label">
                                <Span css="word" text={this.state.form.textos.BODY.INPUT.HEADER.SOLICITANTE.APELLIDO_MAT} />
                            </div>
                            <InputText id="apmatsoli" placeholder={this.state.form.textos.BODY.INPUT.PLACEHOLDER.SOLICITANTE.APELLIDO_MAT} value={this.state.form.reclamo.solicitante.apellidoMaterno} max={20} onlyText={true} onChange={this.validaNombre} />
                            {this.state.form.alerta.estado.solicitante.apellidoMaterno ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.solicitante.apellidoMaterno} /></div> : <div></div>}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                            <div style={{ width: "97%" }}>
                                <div className="label">
                                    <Span css="word" text={this.state.form.textos.BODY.INPUT.HEADER.SOLICITANTE.RUT} />
                                </div>
                                <InputRut id="rutsoli" placeholder={this.state.form.textos.BODY.INPUT.PLACEHOLDER.SOLICITANTE.RUT} value={this.state.form.reclamo.solicitante.rut} max={13} onChange={this.validaRut} />
                                {this.state.form.alerta.estado.solicitante.rut ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.solicitante.rut} /></div> : <div></div>}
                            </div>
                        </Col>
                    </Row>

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="label">
                                <Span css="word" text={this.state.form.textos.BODY.INPUT.HEADER.SOLICITANTE.CORREO} />
                            </div>
                            <InputText id="correo" placeholder={this.state.form.textos.BODY.INPUT.PLACEHOLDER.SOLICITANTE.CORREO} value={this.state.form.reclamo.solicitante.correo} max={60} onlyText={false} onChange={this.validaCorreo} />
                            {this.state.form.alerta.estado.solicitante.correo ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.solicitante.correo} /></div> : <div></div>}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                            <div style={{ width: "97%" }}>
                                <div className="label">
                                    <Span text={this.state.form.textos.BODY.INPUT.HEADER.SOLICITANTE.TELEFONO} />
                                </div>
                                <InputNumerico id="telesoli" placeholder={this.state.form.textos.BODY.INPUT.PLACEHOLDER.SOLICITANTE.TELEFONO} value={this.state.form.reclamo.solicitante.telefono} max={18} onChange={this.validaNumerico} />
                                {this.state.form.alerta.estado.solicitante.telefono ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.solicitante.telefono} /></div> : <div></div>}
                            </div>
                        </Col>
                    </Row>

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="label">
                                <Span css="word" text={this.state.form.textos.BODY.INPUT.HEADER.SOLICITANTE.CELULAR} />
                            </div>
                            <InputNumerico id="celsoli" placeholder={this.state.form.textos.BODY.INPUT.PLACEHOLDER.SOLICITANTE.CELULAR} value={this.state.form.reclamo.solicitante.celular} max={18} onChange={this.validaNumerico} />
                            {this.state.form.alerta.estado.solicitante.celular ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.solicitante.celular} /></div> : <div></div>}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                            <div style={{ width: "97%" }}>

                            </div>
                        </Col>
                    </Row>

                    <div className="label" style={{ color: 'red' }}>
                        <p></p>
                        <Span css="word" text={this.state.form.textos.HEADER.TITULOS.TIT_TRANSACCION} />
                    </div>
                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="label">
                                <Span text={this.state.form.textos.BODY.INPUT.HEADER.VENTA.TRANSACCION} />
                            </div>
                            <InputNumerico id="trxsoli" placeholder={this.state.form.textos.BODY.INPUT.PLACEHOLDER.VENTA.TRANSACCION} value={this.state.form.reclamo.detalleVenta.transaccion} max={12} onChange={this.validaNumerico} />
                            {this.state.form.alerta.estado.venta.transaccion ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.venta.transaccion} /></div> : <div></div>}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                        </Col>
                    </Row>

                    {this.state.form.reclamo.flag.flgBoletos ? <>
                        <div className="label" style={{ color: 'red' }}>
                            <p></p>
                            <Span css="word" text={this.state.form.textos.HEADER.TITULOS.TIT_BOLETOS} />
                        </div>
                        <Row className="transaction-radio-row justify">
                            <Col flex="1 1 150px">
                                {
                                    [...this.state.form.reclamo.boleto.listaBoletos].map(item =>
                                        <div key={item.id}>
                                            <input value={item.id} type="checkbox" onChange={this.isChecked} />
                                            <span>  {item.detalle}</span>
                                        </div>

                                    )
                                }
                                {this.state.form.alerta.estado.boleto.boletosAnular ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.boleto.boletosAnular} /></div> : <div></div>}
                            </Col>
                            <Col flex="0 1 11px"></Col>
                            <Col flex="1 1 150px">
                            </Col>
                        </Row>

                        <Row className="transaction-radio-row">
                            <Col flex="1 1 150px">
                                <div className="label" style={{ color: 'red' }}>
                                    <Span text={this.state.form.textos.HEADER.TITULOS.TIT_OPCION_DEVOLUCION} />
                                </div>
                                <Radio.Group onChange={this.tipoDeDevolucion}>
                                    <Radio value={1}>{this.state.form.textos.BODY.RADIO.OPCIONES.TURCLUB}</Radio>
                                    <Radio value={2}>{this.state.form.textos.BODY.RADIO.OPCIONES.BANCARIA}</Radio>
                                </Radio.Group>
                                {this.state.form.alerta.estado.reclamo.tipoDevolucion ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.reclamo.tipoDevolucion} /></div> : <div></div>}
                            </Col>
                            <Col flex="0 1 11px"></Col>
                            <Col flex="1 1 150px">
                            </Col>
                        </Row>

                        {this.state.form.reclamo.flag.flgDetalleCuenta ? <>

                            <div className="label" style={{ color: 'red' }}>
                                <p></p>
                                <Span css="word" text={this.state.form.textos.HEADER.TITULOS.TIT_COMPRADOR} />
                            </div>
                            <Row className="transaction-radio-row">
                                <Col flex="1 1 150px">
                                    <div className="label">
                                        <Span css="word" text={this.state.form.textos.BODY.INPUT.HEADER.COMPRADOR.RUT} />
                                    </div>
                                    <InputRut id="rutcomp" placeholder={this.state.form.textos.BODY.INPUT.PLACEHOLDER.COMPRADOR.RUT} value={this.state.form.reclamo.comprador.rut} max={13} onChange={this.validaRut} />
                                    {this.state.form.alerta.estado.comprador.rut ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.comprador.rut} /></div> : <div></div>}
                                </Col>
                                <Col flex="0 1 11px"></Col>
                                <Col flex="1 1 150px">
                                    <div style={{ width: "97%" }}>
                                        <div className="label">
                                            <Span css="word" text={this.state.form.textos.BODY.INPUT.HEADER.COMPRADOR.NOMBRE} />
                                        </div>
                                        <InputText id="nomcomp" placeholder={this.state.form.textos.BODY.INPUT.PLACEHOLDER.COMPRADOR.NOMBRE} value={this.state.form.reclamo.comprador.nombre} max={20} onlyText={true} onChange={this.validaNombre} />
                                        {this.state.form.alerta.estado.comprador.nombre ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.comprador.nombre} /></div> : <div></div>}
                                    </div>
                                </Col>
                            </Row>

                            <Row className="transaction-radio-row">
                                <Col flex="1 1 150px">
                                    <div className="label">
                                        <Span css="word" text={this.state.form.textos.BODY.INPUT.HEADER.COMPRADOR.APELLIDO_PAT} />
                                    </div>
                                    <InputText id="appatcomp" placeholder={this.state.form.textos.BODY.INPUT.PLACEHOLDER.COMPRADOR.APELLIDO_PAT} value={this.state.form.reclamo.comprador.apellidoPaterno} max={20} onlyText={true} onChange={this.validaNombre} />
                                    {this.state.form.alerta.estado.comprador.apellidoPaterno ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.comprador.apellidoPaterno} /></div> : <div></div>}
                                </Col>
                                <Col flex="0 1 11px"></Col>
                                <Col flex="1 1 150px">
                                    <div style={{ width: "97%" }}>
                                        <div className="label">
                                            <Span css="word" text={this.state.form.textos.BODY.INPUT.HEADER.COMPRADOR.APELLIDO_MAT} />
                                        </div>
                                        <InputText id="apmatcomp" placeholder={this.state.form.textos.BODY.INPUT.PLACEHOLDER.COMPRADOR.APELLIDO_MAT} value={this.state.form.reclamo.comprador.apellidoMaterno} max={20} onlyText={true} onChange={this.validaNombre} />
                                        {this.state.form.alerta.estado.comprador.apellidoMaterno ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.comprador.apellidoMaterno} /></div> : <div></div>}
                                    </div>
                                </Col>
                            </Row>

                            <div className="label" style={{ color: 'red' }}>
                                <p></p>
                                <Span css="word" text={this.state.form.textos.HEADER.TITULOS.TIT_BANCARIO} />
                            </div>
                            <Row className="transaction-radio-row">
                                <Col flex="1 1 150px">
                                    <div className="label">
                                        <Span css="word" text={this.state.form.textos.BODY.SELECT.HEADER.BANCO} />
                                    </div>
                                    <SelectComponent id="bancos" onChange={this.setBanco} data={this.state.form.bancos} selected={this.state.form.reclamo.comprador.cuenta.banco} inActive={false} />
                                    {this.state.form.alerta.estado.cuenta.banco ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.cuenta.banco} /></div> : <div></div>}
                                </Col>
                                <Col flex="0 1 11px"></Col>
                                <Col flex="1 1 150px">
                                    <div style={{ width: "97%" }}>
                                        <div className="label">
                                            <Span css="word" text={this.state.form.textos.BODY.SELECT.HEADER.CUENTA} />
                                        </div>
                                        <SelectComponent id="cuentas" onChange={this.setCuenta} data={this.state.form.tiposDeCuenta} selected={this.state.form.reclamo.comprador.cuenta.tipo} inActive={false} />
                                        {this.state.form.alerta.estado.cuenta.tipo ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.cuenta.tipo} /></div> : <div></div>}
                                    </div>
                                </Col>
                            </Row>

                            <Row className="transaction-radio-row">
                                <Col flex="1 1 150px">
                                    <div className="label">
                                        <Span css="word" text={this.state.form.textos.BODY.INPUT.HEADER.COMPRADOR.NUM_CUENTA} />
                                    </div>
                                    <InputNumerico id="cuenta" placeholder={this.state.form.textos.BODY.INPUT.PLACEHOLDER.COMPRADOR.NUM_CUENTA} value={this.state.form.reclamo.comprador.cuenta.numero} max={20} onChange={this.validaNumerico} />
                                    {this.state.form.alerta.estado.cuenta.numero ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.cuenta.numero} /></div> : <div></div>}
                                </Col>
                                <Col flex="0 1 11px"></Col>
                                <Col flex="1 1 150px">
                                    <div style={{ width: "97%" }}>
                                    </div>
                                </Col>
                            </Row>
                        </> : <></>}
                    </> : <></>}

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="label">
                                <Span css="word" text={this.state.form.textos.BODY.INPUT.HEADER.RECLAMO.COMENTARIO} />
                            </div>
                            <TextAera id="comensoli" placeholder={this.state.form.textos.BODY.INPUT.PLACEHOLDER.RECLAMO.COMENTARIO} value={this.state.form.reclamo.detalleReclamo.comentario} max={1050} onChange={this.validaTexto} />
                            {this.state.form.alerta.estado.reclamo.comentario ? <div className="informacion label"><Span text={this.state.form.alerta.mensaje.reclamo.comentario} /></div> : <div></div>}
                            {this.state.form.alerta.estado.reclamo.contenedor ? <div className="label"> <Span text={this.state.form.alerta.mensaje.reclamo.contenedor} /></div> : <div></div>}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                            <div style={{ width: "97%" }}>
                            </div>
                        </Col>
                    </Row>

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="label">
                                <p></p><Span text={this.state.form.textos.BODY.INPUT.HEADER.RECLAMO.ADJUNTO} />
                                <UploadeFileReclamo onChange={this.cargaFile} preload={this.state.form.reclamo.detalleReclamo.files} />
                            </div>
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                            <div style={{ width: "97%" }}>
                            </div>
                        </Col>
                    </Row>

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="recaptcha">
                                <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_WEB_KEY}>
                                    <GoogleReCaptcha onVerify={this.verifyCaptcha} />
                                </GoogleReCaptchaProvider>
                            </div>
                        </Col>
                    </Row>

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <Button color="success" onClick={() => this.handleOk(this.state.form)}>{this.state.form.textos.BODY.BUTTON.ENVIAR}</Button>{' '}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                            <div style={{ width: "97%" }}>
                            </div>
                        </Col>
                    </Row>
                </Row>

            </div>
        );
    }
}
